module.exports = __webpack_public_path__ + "static/media/circle-black.56455c95.svg";